import React from "react";
import ReactModal from "react-modal";
import Loader from "../../../common/loader.jsx";
import axios, {
  errorHandler,
  responseHandler,
} from "../../../requests/axios.js";
import { toast } from "react-toastify";
import DataTable from "../../../components/data-table/data-table.jsx";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Link } from "react-router-dom";

export default function AttachChannelToOrgDialog({
  onClose,
  onConfirm,
  isOpen,
  organisationId,
}) {
  const [isLoading, setLoading] = React.useState(false);
  const [linkIds, setLinkIds] = React.useState([]);
  const [error, setError] = React.useState("");

  const fetchLinkIds = React.useCallback(() => {
    axios
      .get(`api/organisations/${organisationId}/channels`)
      .then(
        responseHandler((resp) =>
          setLinkIds(resp.data.map((channel) => channel.channel_id))
        )
      )
      .catch(
        errorHandler((e) => {
          console.error(e);
          toast.error("Error fetching Channel Ids");
        })
      );
  }, [organisationId]);

  React.useEffect(() => {
    fetchLinkIds();
  }, [fetchLinkIds]);

  function onSubmit(channelId) {
    setLoading(true);
    axios
      .post(`api/organisations/${organisationId}/channels/${channelId}`)
      .then(
        responseHandler(() => {
          toast.success("Channel linked to Organisation");
          onConfirm();
          fetchLinkIds();
        })
      )
      .catch(
        errorHandler((err) => {
          console.error(err);
          setError("Something went wrong while contacting the server");
        })
      )
      .finally(() => {
        setLoading(false);
      });
  }

  const columns = [
    {
      label: "Channel Name",
      key: "channel_display_name",
      value: "channel_display_name",
      width: 30,
      renderValue: (row) => (
        <Link
          to={`/admin/channels/${row.channel_id}`}
          className={`data-table__cell__value`}
          target="_blank"
          rel="noreferrer"
          onClick={() => document.activeElement.blur()}
        >
          {row.channel_display_name}
        </Link>
      ),
    },
    {
      label: "",
      value: "",
      key: "0",
      width: 15,
      renderValue: (row) => {
        return !linkIds.find((id) => id === row.channel_id) ? (
          <span className="data-table__action-cell">
            <button
              className="btn btn--icon"
              onClick={() => onSubmit(row.channel_id)}
              aria-label="Link Channel to Organisation"
              data-balloon-pos="left"
            >
              <AddRoundedIcon />
            </button>
          </span>
        ) : null;
      },
    },
  ];

  return (
    <ReactModal isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false}>
      <div className="v-react-modal__inner modal-width modal-width--larger">
        <div className="v-react-modal__heading">Select Channel to link</div>
        <div className="v-react-modal__body v-react-modal__body--table-container modal-body">
          {error ? (
            <p className="u-fc--warning">{error}</p>
          ) : (
            <DataTable url={`api/channels`} columns={columns} />
          )}
        </div>
        <div className="v-react-modal__footer">
          {isLoading ? (
            <Loader width={45} height={45} />
          ) : (
            <React.Fragment>
              <button
                className="btn btn--primary"
                onClick={onClose}
                key="close"
              >
                Close
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </ReactModal>
  );
}
